<template>
  <a-card :bordered="false" class="voice-config">
    <div class="search-panel">
      <a-button class="search-item-com" type="primary" @click="searchQuery">查询</a-button>
      <a-button class="search-item-com" type="primary" style="margin-left: 10px" @click="handleAdd">添加</a-button>
    </div>

    <a-table
      ref="table"
      size="middle"
      :scroll="{x:'100%'}"
      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="false"
      :loading="loading"
      @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
            <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="handleEnable(record)">{{record.enabled==='1'?'禁用':'启用'}}</a>
          <a-divider type="vertical" />
          <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
            <a>删除</a>
          </a-popconfirm>
        </span>
    </a-table>
    <voice-config-modal ref="modalForm" @ok="modalFormOk"></voice-config-modal>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { getAction ,postAction,putAction} from '@/api/manage'
  import {CACHE_PROJECT_ID} from '@/constants/project'
  import Vue from 'vue'
  import VoiceConfigModal from './voice/VoiceConfigModal'
  export default {
    name: 'VoiceConfig',
    mixins: [JeecgListMixin],
    components: { VoiceConfigModal },
    data(){
      return {
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        columns:[
          {
            title: '名称',
            width: 300,
            dataIndex: 'name',
          },
          {
            title: '模型CODE',
            width: 200,
            dataIndex: 'code',
          },
          {
            title: '优先级',
            width: 100,
            dataIndex: 'priority',
          },
          {
            title: '状态',
            width: 100,
            dataIndex: 'enabled',
            customRender:(text)=>{
              return text==='1'?'启用':'禁用'
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            width:200,
            align:"center",
            scopedSlots: { customRender: 'action' },
          }

        ],
        url:{
          list:'/project/voiceConfig/getConfigAll',
          delete: "/project/voiceConfig/delete",
        },
        disableMixinCreated:true,
      }
    },
    mounted(){
      this.baseQueryParam = Object.assign({projectId:this.projectId,checked:'0'},this.baseQuery)
      this.loadData()
    },
    methods:{
      handleEnable(record){
        const operation = record.enabled==='1'?'禁用':'启用'
        this.$confirm({
          title: `确认${operation}？`,
          content: `是否${operation}？`,
          onOk:  () =>{
            this.loading = true;
            putAction('/project/voiceConfig/edit',{id:record.id,enabled:record.enabled==='1'?'0':'1'}).then(res=>{
              if(res.success){
                this.loadData()
              }
            }).finally(()=>{
              this.loading = false
            })
          }
        });
      },
    }
  }
</script>

<style scoped lang="less">
  .voice-config{
    .header{
      font-size: 24px;
      font-weight: bold;
    }
    .title{
      font-size: 20px;
    }
    .tip{
      color: red;
      font-size: 16px;
    }
    .row-item{
      margin-top: 10px;
    }
  }
</style>
<style lang="less">

</style>